import * as angular from "angular";
import * as _ from "lodash";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";
import {BranchModel} from "../models/branch.model";

export class BranchesRequests {

  /* @ngInject */
  constructor(private branchesAPI: BringozApi, private $branches, private $q) {
  }

  // ******************************
  //        Public methods
  // ******************************

  createBranch(branch: BranchModel) {
    const api = this.branchesAPI.actions.createBranch;
    return this.$$call(api, {}, branch, {});
  }

  editBranch(branchId, branch: BranchModel) {
    const api = this.branchesAPI.actions.editBranch;
    return this.$$call(api, {}, branch, {id: branchId});
  }

  updateExternalId(id: string, branch: BranchModel) {
    const api = this.branchesAPI.actions.updateExternalId;
    return this.$$call(api, {}, branch, {id: id});
  }

  getTotalBranches(ids?: string[], tags?: string[], query?:string, isActive?: boolean) {
    const api = this.branchesAPI.actions.getTotalBranches;
    const isInactive = _.isBoolean(isActive) ? !isActive : undefined;
    return this.$$call(api, {ids: ids, tags: tags, query: query, isInactive: isInactive}, {}, {});
  }

  deleteBranch(branchId: string) {
    const api = this.branchesAPI.actions.deleteBranch;
    return this.$$call(api, {}, {}, {id: branchId});
  }

  addMembers(branchId: string, memberIds) {
    const api = this.branchesAPI.actions.addMembers;
    return this.$$call(api, {}, memberIds, {id: branchId});
  }

  removeMembers(branchId: string, memberIds) {
    const api = this.branchesAPI.actions.removeMembers;
    return this.$$call(api, {}, memberIds, {id: branchId});
  }

  // Same contract as $branches().$asyncValues: resolves the branches for the given ids, in that
  // order, hitting the API only for the ones the store does not hold yet.
  getBranchesByIds(ids: string[]) {
    const branchesRef = this.$branches();
    const cached: BranchModel[] = _.filter(branchesRef.$values(ids), (branch) => !_.isUndefined(branch));
    const missingIds: string[] = _.difference(ids, _.map(cached, 'id'));

    if (!missingIds.length) {
      return this.$q.when(this.sortByIds(ids, cached));
    }

    const api = this.branchesAPI.actions.query;
    return branchesRef.$call(api, {}, {ids: missingIds}, {})
      .then((branches: BranchModel[]) => this.sortByIds(ids, cached.concat(branches || [])));
  }

  editTags(tags: string[], params?: any, branchIds?: string[], excludedBranchIds?: string[]) {
    const api = this.branchesAPI.actions.bulkUpdate;
    return this.$$call(api, {...params}, {
      tags,
      branchIds,
      excludedBranchIds
    }, {});
  }


  // ******************************
  //        Private methods
  // ******************************


  $$call(_apiCall, _params, _data, _options) {
    return this.$branches().$call(_apiCall, _params, _data, _options);
  }

  private sortByIds(ids: string[], branches: BranchModel[]): BranchModel[] {
    return _.sortBy(branches, (branch: BranchModel) => _.indexOf(ids, branch.id));
  }
}

angular
  .module('bringoz.admin.branches')
  .service('branchesRequests', BranchesRequests);
